// import { Link } from "react-router-dom";
// import type React from "react";
// import {  useState } from "react";
// import type { IShipment } from "../../types/models/shipment.models";
// import type { IResponse } from "../../../types/response.types";
// import { handleHttpError } from "../../../utils/utils";
// import { useToast } from "../../../hooks/use-toast";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "../../components/core/table.core";
// import Button from "../../components/core/button.core";
// import Spinner from "../../../components/spinner.components";
// import { Check, ChevronDown, Search, XIcon } from "lucide-react";
// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuTrigger,
// } from "../../components/core/dropdown.core";
// import SoloThunderIcon from "../../../assets/svgs/common/solo-thunder.svg";
// import ArrowTopRightIcon from "../../../assets/svgs/common/arrow-top-right.svg";

// enum ShipmentStatus {
//   ALL = "all",
//   PENDING = "pending",
//   SHIPPED = "shipped",
// }

export default function CampaignShipmentsPartial() {
    return<></>
//   const [, setShipped] = useState<boolean | undefined>(undefined);
//   const [shipments, setShipments] = useState<[]>([]);
//   const [selectedShipmentIds, setSelectedShipmentIds] = useState<string[]>([]);
//   const [loading, ] = useState(true);
//   const [bulkLoading, setBulkLoading] = useState(false);
//   const [searchValue, setSearchValue] = useState<string>("");
//   const [searchResults, setSearchResults] = useState<IShipment[] | undefined>();
//   const [selectedStatus, setSelectedStatus] = useState<ShipmentStatus>(
//     ShipmentStatus.ALL
//   );

//   const shipmentHeaders = [
//     {
//       header: "",
//       key: "checkbox",
//     },
//     {
//       header: "Creator",
//       key: "creator",
//     },
//     {
//       header: "Name",
//       key: "name",
//     },
//     {
//       header: "Shipping Address",
//       key: "address",
//     },
//     {
//       header: "Contact no",
//       key: "contact",
//     },
//     {
//       header: "",
//       key: "actions",
//     },
//   ];

//   // Search handler
//   function handleSearchShipments(value: string) {
//     setSearchValue(value);

//     if (!value.trim()) {
//       setSearchResults(undefined);
//       return;
//     }

//     const filtered = shipments.filter(
//       (shipment) =>
//         shipment.social?.handle?.toLowerCase().includes(value.toLowerCase()) ||
//         shipment.address?.address1
//           ?.toLowerCase()
//           .includes(value.toLowerCase()) ||
//         shipment.creator?.phoneNumber?.includes(value)
//     );

//     setSearchResults(filtered);
//   }

//   // Status filter handler
//   function handleStatusChange(status: ShipmentStatus) {
//     setSelectedStatus(status);

//     switch (status) {
//       case ShipmentStatus.ALL:
//         setShipped(undefined);
//         break;
//       case ShipmentStatus.PENDING:
//         setShipped(false);
//         break;
//       case ShipmentStatus.SHIPPED:
//         setShipped(true);
//         break;
//     }
//   }

//   // Get display shipments (search results or all)
//   const displayShipments = searchResults || shipments;

//   // Get only pending shipments (not shipped)
//   const pendingShipments = displayShipments.filter(
//     (shipment) =>
//       shipment.status.status !== "shipped"
//   );

//   // Handle select all checkbox
//   const handleSelectAll = (checked: boolean) => {
//     if (checked) {
//       const allPendingIds = pendingShipments.map((shipment) => shipment.id);
//       setSelectedShipmentIds(allPendingIds);
//     } else {
//       setSelectedShipmentIds([]);
//     }
//   };

//   // Handle individual checkbox
//   const handleSelectShipment = (shipmentId: string, checked: boolean) => {
//     if (checked) {
//       setSelectedShipmentIds((prev) => [...prev, shipmentId]);
//     } else {
//       setSelectedShipmentIds((prev) => prev.filter((id) => id !== shipmentId));
//     }
//   };

//   const handleMarkBulkAsShipped = async () => {
//     setBulkLoading(true);
//   };

//   // Check if all pending shipments are selected
//   const isAllSelected =
//     pendingShipments.length > 0 &&
//     selectedShipmentIds.length === pendingShipments.length;

//   // Check if some (but not all) pending shipments are selected
//   const isIndeterminate =
//     selectedShipmentIds.length > 0 &&
//     selectedShipmentIds.length < pendingShipments.length;

//   if (loading && shipments.length === 0) {
//     return (
//       <div className="flex justify-center items-center w-full h-full">
//         <Spinner width={20} className="text-black" />
//       </div>
//     );
//   }

//   return (
//     <div className="relative pt-5 md:pt-0 w-full h-full overflow-x-auto">
//       {/* Search and Filter Section */}
//       <div className="top-0 z-10 md:sticky bg-white pl-5 border-black border-t border-b w-full">
//         <div className="flex md:flex-row flex-col md:justify-start items-start md:items-center md:gap-4 py-3 md:w-full">
//           {/* Search Bar */}
//           <div className="relative w-full max-w-md">
//             <Search className="top-1/2 left-6 absolute w-4 h-4 text-gray-400 transform -translate-y-1/2" />
//             <input
//               type="text"
//               value={searchValue}
//               onChange={(e) => handleSearchShipments(e.target.value)}
//               placeholder="Search by creator name"
//               className="py-2.5 pr-4 pl-12 border border-black rounded-full w-full font-cabinetgrotesk text-sm md:text-base focus:outline-none focus:ring-2"
//             />
//             {searchResults && (
//               <button
//                 type="button"
//                 onClick={() => {
//                   setSearchResults(undefined);
//                   setSearchValue("");
//                 }}
//                 className="top-1/2 right-3 absolute transform -translate-y-1/2"
//               >
//                 <XIcon className="w-4 h-4 text-gray-400" />
//               </button>
//             )}
//           </div>

//           {/* Status Filter Dropdown */}
//           <div className="flex gap-2 mt-2 md:mt-0 w-full md:w-fit font-cabinetgrotesk">
//             <DropdownMenu>
//               <DropdownMenuTrigger className="focus:outline-none">
//                 <div className="flex items-center gap-1 px-3 py-2.5 border border-black rounded-full text-nowrap text-xs md:text-base">
//                   Status: {selectedStatus}{" "}
//                   <ChevronDown className="ml-1 w-4 h-4" />
//                 </div>
//               </DropdownMenuTrigger>
//               <DropdownMenuContent
//                 align="start"
//                 className="bg-white backdrop-blur-0 w-40 font-cabinetgrotesk font-normal text-soloprimary"
//               >
//                 {Object.values(ShipmentStatus).map((status) => (
//                   <DropdownMenuItem
//                     key={status}
//                     className="flex justify-between items-center p-3 w-full text-sm capitalize"
//                     textValue={status}
//                     onClick={() => handleStatusChange(status)}
//                   >
//                     {status}
//                     {selectedStatus === status && (
//                       <Check className="w-4 h-4 text-black" />
//                     )}
//                   </DropdownMenuItem>
//                 ))}
//               </DropdownMenuContent>
//             </DropdownMenu>
//           </div>
//         </div>
//       </div>

//       {/* Table Section */}
//       <div className="pb-32 border-black border-b w-full">
//         {displayShipments.length === 0 ? (
//           <div className="flex justify-center items-center py-12">
//             <p className="text-gray-500">
//               {searchResults
//                 ? "No shipments found matching your search"
//                 : "No shipments found"}
//             </p>
//           </div>
//         ) : (
//           <Table>
//             <TableHeader className="border-black border-b">
//               <TableRow>
//                 {shipmentHeaders.map((header, index) => (
//                   <TableHead
//                     className={`${index === 0 ? "pl-10 w-12" : ""} ${
//                       index === shipmentHeaders.length - 1 ? "pr-10" : ""
//                     }`}
//                     key={header.key}
//                   >
//                     {index === 0 ? (
//                       // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
//                       <div
//                         onClick={() =>
//                           handleSelectAll(
//                             isIndeterminate ? false : !isAllSelected
//                           )
//                         }
//                         className={`border border-black rounded-full w-5 h-5 overflow-hidden cursor-pointer ${pendingShipments.length === 0 ? "hidden" : ""}`}
//                       >
//                         {isAllSelected ? (
//                           <SoloThunderIcon className="w-full h-full object-cover" />
//                         ) : isIndeterminate ? (
//                           <div className="flex justify-center items-center bg-black w-full h-full">
//                             <div className="bg-white w-2 h-0.5" />
//                           </div>
//                         ) : (
//                           <></>
//                         )}
//                       </div>
//                     ) : (
//                       header.header
//                     )}
//                   </TableHead>
//                 ))}
//               </TableRow>
//             </TableHeader>
//             <TableBody>
//               {displayShipments.map((shipment) => {
//                 const isShipped = true;

//                 const isChecked = selectedShipmentIds.includes(shipment.id);

//                 return (
//                   <TableRow key={shipment.id} className="border-black border-b">
//                     {/* Checkbox */}
//                     <TableCell className="py-4 pl-10 w-12">
//                       {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
//                       <div
//                         onClick={() => {
//                           handleSelectShipment(
//                             shipment.id,
//                             isChecked as boolean
//                           );
//                           setSelectedShipmentIds((prev) =>
//                             isChecked
//                               ? prev.filter((id) => id !== shipment.id)
//                               : [...prev, shipment.id]
//                           );
//                         }}
//                         className={`border border-black cursor-pointer rounded-full w-5 h-5 overflow-hidden ${isShipped ? "hidden" : ""}`}
//                       >
//                         {isChecked ? (
//                           <SoloThunderIcon className="w-full h-full object-cover" />
//                         ) : (
//                           <></>
//                         )}
//                       </div>
//                     </TableCell>

//                     {/* Creator */}
//                     <TableCell className="py-4">
//                       <div className="flex items-center gap-2">
//                         <div className="border border-black rounded-full w-8 h-8 overflow-hidden">
//                           {/* {shipment.social?.profilePicture && (
//                             <img
//                               src={shipment.social.profilePicture}
//                               alt={shipment.social.handle}
//                               className="w-full h-full object-cover"
//                             />
//                           )} */}
//                         </div>
//                         <Link
//                           to={`https://instagram.com/${shipment.social?.handle}/`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="flex items-center gap-1 font-medium text-base underline"
//                         >
//                           {shipment.social?.handle} <ArrowTopRightIcon />
//                         </Link>
//                       </div>
//                     </TableCell>

//                     {/* Name */}
//                     <TableCell className="py-4">
//                       <div className="flex flex-col gap-0.5">
//                         <span className="text-sm">
//                           {shipment.creator.name || "-"}
//                         </span>
//                       </div>
//                     </TableCell>

//                     {/* Shipping Address */}
//                     <TableCell className="py-4">
//                       {shipment.address ? (
//                         <div className="flex flex-col gap-0.5 max-w-xs">
//                           <span className="text-sm">
//                             {shipment.address.address1}
//                           </span>
//                           {shipment.address.address2 && (
//                             <span className="text-sm">
//                               {shipment.address.address2}
//                             </span>
//                           )}
//                           <span className="text-gray-500 text-xs">
//                             {shipment.address.city}, {shipment.address.state}{" "}
//                             {shipment.address.postalCode}
//                           </span>
//                         </div>
//                       ) : (
//                         "-"
//                       )}
//                     </TableCell>

//                     {/* Contact Number */}
//                     <TableCell className="py-4">
//                       <span className="text-sm">
//                         {shipment.creator.phoneNumber || "-"}
//                       </span>
//                     </TableCell>

//                     {/* Actions */}
//                     <TableCell className="py-4 pr-10 w-48">
//                       <MarkAsShipped
//                         setShipments={setShipments}
//                         shipment={shipment}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 );
//               })}
//             </TableBody>
//           </Table>
//         )}
//       </div>

//       {/* Bulk Action Footer */}
//       {selectedShipmentIds.length > 0 && (
//         <div className="bottom-0 left-0 z-0 fixed flex justify-end gap-4 bg-white p-4 border-black border-t w-full">
//           <div className="flex gap-3">
//             <Button
//               variant="secondary"
//               onClick={() => setSelectedShipmentIds([])}
//               className="text-sm"
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handleMarkBulkAsShipped}
//               isLoading={bulkLoading}
//               disabled={bulkLoading}
//               className="p-0 w-40 h-14 text-sm"
//             >
//               Mark as shipped
//             </Button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
}

// const MarkAsShipped = ({
//   shipment,
//   setShipments,
// }: {
//   shipment: IShipment;
//   setShipments: React.Dispatch<React.SetStateAction<IShipment[]>>;
// }) => {
//   const { toast } = useToast();
//   const [loading, setLoading] = useState(false);

//   const handleMarkAsShipped = async () => {
//     setLoading(true);
//   };

//   const isShipped = true;

//   return (
//     <Button
//       variant="secondary"
//       disabled={isShipped || loading}
//       isLoading={loading}
//       onClick={handleMarkAsShipped}
//       className="py-0 w-48 h-14 text-nowrap text-sm"
//     >
//       {isShipped ? "Shipped" : "Mark as shipped"}
//     </Button>
//   );
// };
